
<template>
  <!--会员信息-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="memberId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_t" slot-scope="{row}">
        <span>{{row.mobilePhone}}</span>
      </template>
    </x-tabula>
    <a-modal v-model="visible" title="账户余额" okText="关闭" @ok="visible = false" :footer="null">
      <div class="box">
        <div>当前余额: <span class="account-money">¥{{balance}}</span></div>
        <a-button type="primary" @click="checkExpenseRecord">消费记录</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'members',
  data () {
    return {
      visible: false,
      balance: '',
      currentRow: {},
      searchList: [
        { props: ['communityId'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['keywords'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['sex'], placeholder: '性别', options: this.$store.state.sexList, inputType: 'select' },
        { props: ['fromMode'], placeholder: '注册来源', options: [], inputType: 'select' },
        { props: ['fromOs'], placeholder: '注册平台', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['isBindWeixin'], placeholder: '微信绑定', options: this.$store.state.isBandList, inputType: 'select' },
        { props: ['registerDate'], placeholder: ['注册时间', '注册时间'], options: [], inputType: 'datePick' },
        { props: ['loginDate'], placeholder: ['最近登录时间', '最近登录时间'], options: [], inputType: 'datePick' },
        { props: ['isGetFace'], placeholder: ['是否采集人脸'], options: [{label: '是', value: 1}, {label: '否', value: 0}], inputType: 'select' },
        { props: ['isGetEigenvalue'], placeholder: ['是否有特征值'], options: [{label: '是', value: 1}, {label: '否', value: 0}], inputType: 'select' }
      ],
      searchParams: {
        communityId: undefined,
        keywords: undefined,
        sex: undefined,
        fromMode: undefined,
        fromOs: undefined,
        status: undefined,
        isBindWeixin: undefined,
        registerDate: undefined,
        loginDate: undefined,
        isGetFace: undefined,
        isGetEigenvalue: undefined
      },
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.memberId), permi: ['community:member:query'] },
        { text: '住房信息', handle: (row) => this.toHousingInfo(row.memberId), permi: ['community:member:room:list'] },
        { text: '', handle: (row) => this.switchStatus(row), customRender: true, permi: ['community:member:editstatus'] },
        [
          { text: '账户余额', handle: this.toConsumeRecord, permi: ['community:member:balance'] }
        ]
      ],
      columns: [
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '性别', dataIndex: 'sexDesc', align: 'left', width: '' },
        { title: '注册来源', dataIndex: 'fromModeDesc', align: 'left', width: '' },
        { title: '注册平台', dataIndex: 'fromOsDesc', align: 'left', width: '' },
        { title: '注册时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '最近登录时间', dataIndex: 'lastLoginTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/member/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      let paramArr = [
        {index: 3, scope: 'searchList', query: 'comu_member_register_type'},
        {index: 4, scope: 'searchList', query: 'comu_member_register_platform'}
      ];
      this.dictionarySelect(paramArr);
    },
    /* 查看会员详情 */
    toDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 查看住房信息 */
    toHousingInfo (id) {
      this.$router.push({
        name: 'housingInfo',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 切换会员状态 */
    switchStatus (row) {
      let newStaus = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/member/changeStatus/${row.memberId}`,
        params: { status: newStaus }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    // 查看账户余额
    toConsumeRecord (row) {
      this.currentRow = row;
      this.$get({
        url: `/member/accounts/${row.memberId}`
      }).then(res => {
        this.balance = res.data.balance;
      });
      this.visible = true;
    },
    // 前往消费记录
    checkExpenseRecord () {
      this.visible = false;
      this.$router.push({
        name: 'memberRecord',
        query: {
          id: this.currentRow.memberId,
          title: `消费记录(${this.currentRow.nickName})`,
          breadNumber: 1,
          ...this.breadParam(this)
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>

<style lang="less" scoped>
.box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  vertical-align: middle;
}
</style>
